import React, { useState, useEffect, useRef, useMemo } from 'react';
import { listarMunicipios, filtrarMunicipios, municipioPorCodigo } from '../services/municipios';

/* Campo de município com busca, usado na emissão de NFS-e e nos perfis de
   tributação. Guarda e devolve o CÓDIGO IBGE (7 dígitos), que é o que a
   DPS exige -- o nome é só pra pessoa achar.

   Reutilizável: recebe o estilo por prop em vez de importar um CSS module
   de um módulo específico, senão ficaria preso à tela onde nasceu. */
function SeletorMunicipio({ valor, onChange, className, placeholder = 'Digite o município...', autoFocus }) {
  const [lista, setLista] = useState([]);
  const [busca, setBusca] = useState('');
  const [aberto, setAberto] = useState(false);
  const [erro, setErro] = useState('');
  const caixaRef = useRef(null);

  useEffect(() => {
    listarMunicipios().then(setLista).catch(e => setErro(e.message));
  }, []);

  /* clicar fora fecha a lista -- sem isso ela fica aberta por cima do
     resto do formulário */
  useEffect(() => {
    function aoClicarFora(e) {
      if (caixaRef.current && !caixaRef.current.contains(e.target)) setAberto(false);
    }
    document.addEventListener('mousedown', aoClicarFora);
    return () => document.removeEventListener('mousedown', aoClicarFora);
  }, []);

  const selecionado = useMemo(() => municipioPorCodigo(lista, valor), [lista, valor]);
  const sugestoes = useMemo(() => (aberto ? filtrarMunicipios(lista, busca) : []), [aberto, lista, busca]);

  /* enquanto a lista não chegou, mostra o código salvo pra não parecer que
     o campo está vazio */
  const textoCampo = aberto
    ? busca
    : (selecionado ? `${selecionado.nome}/${selecionado.uf}` : (valor || ''));

  return (
    <div ref={caixaRef} style={{ position: 'relative' }}>
      <input
        className={className}
        value={textoCampo}
        placeholder={placeholder}
        autoFocus={autoFocus}
        onFocus={() => { setAberto(true); setBusca(''); }}
        onChange={e => { setBusca(e.target.value); setAberto(true); }}
      />
      {erro && <span style={{ fontSize: 11, color: '#b91c1c' }}>{erro}</span>}

      {aberto && sugestoes.length > 0 && (
        <ul style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 40,
          margin: '2px 0 0', padding: 0, listStyle: 'none', background: '#fff',
          border: '1px solid #d7e3ef', borderRadius: 8, maxHeight: 220,
          overflowY: 'auto', boxShadow: '0 8px 20px rgba(13,31,60,0.12)',
        }}>
          {sugestoes.map(m => (
            <li
              key={m.codigo}
              onClick={() => { onChange(m.codigo); setAberto(false); setBusca(''); }}
              style={{ padding: '7px 10px', fontSize: 13, cursor: 'pointer' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#f5f8fc'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#fff'; }}
            >
              {m.nome}/{m.uf}
              <span style={{ color: '#93a1b3', marginLeft: 6, fontSize: 11.5 }}>{m.codigo}</span>
            </li>
          ))}
        </ul>
      )}

      {aberto && busca && sugestoes.length === 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 40,
          marginTop: 2, padding: '7px 10px', background: '#fff', fontSize: 12.5,
          color: '#93a1b3', border: '1px solid #d7e3ef', borderRadius: 8,
        }}>
          Nenhum município encontrado.
        </div>
      )}
    </div>
  );
}

export default SeletorMunicipio;
